export default "__VITE_ASSET__CbgCO5sK__"